// material
import { Avatar, useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

// ----------------------------------------------------------------------

const MAvatar = forwardRef(({ children, color = 'default', sx, ...other }, ref) => {
  const theme = useTheme();

  if (color === 'default') {
    return (
      <Avatar ref={ref} sx={sx} {...other}>
        {children}
      </Avatar>
    );
  }

  return (
    <Avatar
      ref={ref}
      sx={{
        backgroundColor: theme.palette[color].main,
        color: theme.palette[color].contrastText,
        fontWeight: theme.typography.fontWeightMedium,
        ...sx,
      }}
      {...other}
    >
      {children}
    </Avatar>
  );
});

MAvatar.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'info', 'success', 'warning', 'error']),
  // eslint-disable-next-line react/forbid-prop-types
  sx: PropTypes.object,
};

export default MAvatar;
